// frontend/src/services/mpesa.js
import api from './api';

export const mpesaService = {
    initiateSTKPush: (data) => api.post('/mpesa/stk-push', data).then(res => res.data),
    queryStatus: (checkoutRequestId) => api.post('/mpesa/query', { checkoutRequestId }).then(res => res.data),
};